'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["isExternal", "target", "rel", "className"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Link Overlay
 *
 * Provides a semantic way to wrap elements in a link. It overlays a link on
 * top of the component.
 *
 * The component has to be wrapped with `<LinkBox />`.
 *
 * @see https://chakra-ui.com/docs/components/navigation/link-overlay
 */
var LinkOverlay = react.forwardRef(function (props, ref) {
  var linkStyles = react.useStyleConfig('Link', props);
  var _omitThemingProps = react.omitThemingProps(props),
    isExternal = _omitThemingProps.isExternal,
    target = _omitThemingProps.target,
    rel = _omitThemingProps.rel,
    className = _omitThemingProps.className,
    rest = _objectWithoutProperties__default["default"](_omitThemingProps, _excluded);
  var linkOverlayStyles = _objectSpread(_objectSpread({}, linkStyles), {}, {
    position: 'static',
    '&::before': {
      content: "''",
      cursor: 'inherit',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      width: '100%',
      height: '100%'
    }
  });
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.a, _extends__default["default"]({}, rest, {
    ref: ref,
    className: utils.cx('chakra-linkbox__overlay', className),
    rel: isExternal ? 'noopener noreferrer' : rel,
    target: isExternal ? '_blank' : target,
    __css: linkOverlayStyles
  }));
});
LinkOverlay.displayName = 'LinkOverlay';
exports.LinkOverlay = LinkOverlay;